//libraries

import "../css/Website.scss";

//Components
// import Icon from "components/Icons/Icon";
import Footer from "../components/Footer";
import LanguageSwitcher from "../components/LanguageSwitcher";

import Navigation from "../components/navigation/Navigation";

import Facebook from "../img/fb.png";
import Insta from "../img/insta.png";
// import Twitter from "../img/twitter.png";
import Icon from "components/Icons/Icon";
import OutroCTA from "../components/OutroCTA";
import { t } from "i18n/index";

interface ContactProps {
  lang?: string;
  uiTranslations?: Record<string, string>;
}

const Contact = ({ uiTranslations = {} }: ContactProps) => {
  return (
    <div id="stippl-contact">
      <Navigation impact={false} langMenu={<LanguageSwitcher type="page" />} />
      <section className="intro-header intro-header--light">
        <div className="container__inner">
          <div className="intro-header__content">
            <h1>{t(uiTranslations, "contact.heading", "Contact")}</h1>
          </div>
        </div>
      </section>

      <div className="container__full-width">
        <section className="contact">
          <div className="container__inner">
            <div className="contact__content">
              <div className="contact__column">
                <h3>{t(uiTranslations, "contact.contactUsHeading", "Contact us")}</h3>
                <p>
                  {t(
                    uiTranslations,
                    "contact.contactUsIntro",
                    "Have cool ideas, feedback or want to work together? Drop us a message and we’ll get back to you!"
                  )}
                </p>
                <ul className="socials">
                  <li>
                    <a href="https://www.instagram.com/stippl.io/" target="_blank" rel="noreferrer">
                      <img src={Insta} alt="instagram logo" />
                      @stippl.io
                    </a>
                  </li>
                  <li>
                    <a href="https://www.tiktok.com/@stippl.io" target="_blank" rel="noreferrer">
                      <Icon name="tiktok" />
                      @stippl.io
                    </a>
                  </li>
                  <li>
                    <a href="https://www.facebook.com/stippl/" target="_blank" rel="noreferrer">
                      <img src={Facebook} alt="Facebook logo" />
                      /stippl
                    </a>
                  </li>

                  <li>
                    <a href="mailto:support@stippl.io">
                      <Icon name="mail" />

                      <div className="double-line">
                        <span className="small">{t(uiTranslations, "contact.supportLabel", "For support questions:")}</span>
                        <span>support@stippl.io</span>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a href="mailto:info@stippl.io">
                      <Icon name="mail" />
                      <div className="double-line">
                        <span className="small">{t(uiTranslations, "contact.businessLabel", "For business inquiries:")}</span>
                        <span>info@stippl.io</span>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
              <div className="contact__column">
                <h3>{t(uiTranslations, "contact.shareHeading", "Share your experience")}</h3>
                <p>
                  {t(
                    uiTranslations,
                    "contact.shareIntro",
                    "We value your thoughts and opinions, as they help us grow and improve. Your feedback is greatly appreciated!"
                  )}
                </p>
                <a href="/survey" className="btn-rounded solid xl">
                  {t(uiTranslations, "contact.takeSurvey", "Take survey")}
                </a>
              </div>
            </div>
          </div>
        </section>
      </div>
      <OutroCTA />
      <Footer />
    </div>
  );
};

export default Contact;
